import { toast } from "@/hooks/use-toast"
import { differenceInDays } from "date-fns"
import { REPORT_MAX_DAYS_DIFFERENCE } from "@/constants/forms-validation"

// Silent validation for URL query params (no toasts)
export const isValidDateRange = (
  paymentDateInit: string | undefined,
  paymentDateEnd: string | undefined
): boolean => {
  if (!paymentDateInit || !paymentDateEnd) {
    return false
  }

  const paymentDateInitDate = new Date(paymentDateInit)
  const paymentDateEndDate = new Date(paymentDateEnd)

  // Check if dates are valid
  if (
    isNaN(paymentDateInitDate.getTime()) ||
    isNaN(paymentDateEndDate.getTime())
  ) {
    return false
  }

  const daysDifference = differenceInDays(
    paymentDateEndDate,
    paymentDateInitDate
  )

  // Check if end date is after start date and within 90 days
  return (
    daysDifference >= 0 &&
    daysDifference <= REPORT_MAX_DAYS_DIFFERENCE
  )
}

// Validation with toast messages for form submission
export const validateDateRange = (
  paymentDateInit: string | undefined,
  paymentDateEnd: string | undefined,
  onValidationError?: () => void
): boolean => {
  const paymentDateInitDate = paymentDateInit
    ? new Date(paymentDateInit)
    : undefined
  const paymentDateEndDate = paymentDateEnd
    ? new Date(paymentDateEnd)
    : undefined

  // If both dates are missing, consider it valid (no validation needed)
  if (!paymentDateInitDate && !paymentDateEndDate) {
    return true
  }

  // If only one date is provided, it's invalid
  if (
    (paymentDateInitDate && !paymentDateEndDate) ||
    (!paymentDateInitDate && paymentDateEndDate)
  ) {
    toast({
      title: "Erro de validação",
      description: `Selecione um período de pagamento completo (data inicial e final)`,
      variant: "destructive",
    })
    onValidationError?.()
    return false
  }

  // Both dates are provided, validate the range
  if (paymentDateInitDate && paymentDateEndDate) {
    const daysDifference = differenceInDays(
      paymentDateEndDate,
      paymentDateInitDate
    )

    if (daysDifference < 0) {
      toast({
        title: "Período inválido",
        description:
          "A data final deve ser posterior à data inicial",
        variant: "destructive",
      })
      onValidationError?.()
      return false
    }

    if (daysDifference > REPORT_MAX_DAYS_DIFFERENCE) {
      toast({
        title: "Período muito longo",
        description: `O período de pagamento não pode ser maior que ${REPORT_MAX_DAYS_DIFFERENCE} dias`,
        variant: "destructive",
      })
      onValidationError?.()
      return false
    }
  }

  return true
}
